var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.optional)?_c('el-table-column',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._t("default",null,null,scope)]}}],null,true)},'el-table-column',_vm.attrs,false)):_c('el-table-column',_vm._b({},'el-table-column',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }